
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("dhbEh", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $inPa6 = parcelRequire("inPa6");


var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $7QUD1 = parcelRequire("7QUD1");


var $hIaUw = parcelRequire("hIaUw");


var $8a9Dm = parcelRequire("8a9Dm");


var $dizL5 = parcelRequire("dizL5");


var $bQm3c = parcelRequire("bQm3c");


var $ep3mz = parcelRequire("ep3mz");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $3IBnw = parcelRequire("3IBnw");


var $7Sm4c = parcelRequire("7Sm4c");


var $5ZqQS = parcelRequire("5ZqQS");


var $3jwuS = parcelRequire("3jwuS");


var $c54hr = parcelRequire("c54hr");














var $9hlns = parcelRequire("9hlns");


var $9fBoq = parcelRequire("9fBoq");


var $al4VD = parcelRequire("al4VD");

const $ced39bfea5ef5993$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isLoading: isLoading, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_kqswh2mm",
            __cmplp.isLoading ? "_syaz1rpy" : "_syazn7od",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $ced39bfea5ef5993$var$CenterSpinner = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_18u0x0bf _19pkx0bf _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
function $ced39bfea5ef5993$export$9f275aff884e1431(t0) {
    const $ = (0, $frIzR.c)(16);
    const { extension: extension, onClick: onClick, isLoading: isLoading } = t0;
    let t1;
    if ($[0] !== extension || $[1] !== onClick) {
        t1 = (e)=>{
            e.stopPropagation();
            onClick(extension);
        };
        $[0] = extension;
        $[1] = onClick;
        $[2] = t1;
    } else t1 = $[2];
    const onClickCB = t1;
    const t2 = extension.id;
    let t3;
    if ($[3] !== extension) {
        t3 = (0, $9fBoq.extensionTitle)(extension);
        $[3] = extension;
        $[4] = t3;
    } else t3 = $[4];
    let t4;
    if ($[5] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$CenterSpinner, {
            "data-test-id": "forge-ui-extension-loading-spinner"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
            size: "small"
        }));
        $[5] = isLoading;
        $[6] = t4;
    } else t4 = $[6];
    let t5;
    if ($[7] !== isLoading || $[8] !== t3 || $[9] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($ced39bfea5ef5993$var$Container, {
            isLoading: isLoading
        }, t3, t4);
        $[7] = isLoading;
        $[8] = t3;
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== extension.id || $[12] !== isLoading || $[13] !== onClickCB || $[14] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $al4VD.ContentToolsItem), {
            id: t2,
            isDisabled: isLoading,
            label: t5,
            onClick: onClickCB
        });
        $[11] = extension.id;
        $[12] = isLoading;
        $[13] = onClickCB;
        $[14] = t5;
        $[15] = t6;
    } else t6 = $[15];
    return t6;
}
$ced39bfea5ef5993$export$9f275aff884e1431.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool.isRequired
};



var $9MrOn = parcelRequire("9MrOn");

const $0c33e41081c1500e$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_CONTENT_TOOLS_FORGE_EXPERIENCE);
function $0c33e41081c1500e$export$7cf22b806dbb23cb({ contentId: contentId, spaceKey: spaceKey, children: children, onLoadComplete: onLoadComplete, isDropdownMenuOpen: isDropdownMenuOpen, lazyLoaderPlaceholderComponent: lazyLoaderPlaceholderComponent = null }) {
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext)); // Forge menu items are behaving a little different than other menu items. They show a loading spinner if one of them
    // is clicked. There are a few different cases that needs to be handled while a forge extension is being loaded:
    // 1. Show a loading spinner while an extension id being loaded.
    //    - Stop showing the loading spinner once the extension is loaded.
    //    - Close the dropdown menu once the extension is loaded.
    // 2. If dropdown menu is closed while an extension is being loaded then stop loading the extension.
    // If there's a selected extension then `loadExtension` state changes like this:
    // +----------+----------------------+------------------+
    // |isLoading |   isDropdownMenuOpen |    loadExtension |
    // +----------------------------------------------------+
    // |          |                      |                  |
    // | false    |   false              |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | false    |   true               |    true          |  --> keep showing the loaded extension
    // |          |                      |                  |
    // | true     |   false              |    false         |  --> stop loading the extension
    // |          |                      |                  |
    // | true     |   true               |    true          |  --> keep loading the extension
    // +----------+----------------------+------------------+
    const [extension, showExtension] = (0, $42omo.useState)(null);
    const [isLoading, setLoading] = (0, $42omo.useState)(false);
    const loadExtension = extension && !(isLoading && !isDropdownMenuOpen);
    (0, $42omo.useEffect)(()=>{
        if (!loadExtension) {
            experienceTracker.abort({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
                reason: 'Canceled by user'
            });
            setLoading(false);
            showExtension(null);
        }
    }, [
        loadExtension,
        experienceTracker
    ]);
    const onLoadCompleteCB = (0, $42omo.useCallback)(()=>{
        onLoadComplete();
        setLoading(false);
    }, [
        onLoadComplete,
        setLoading
    ]);
    const onCloseCB = (0, $42omo.useCallback)(()=>{
        showExtension(null);
    }, [
        showExtension
    ]);
    const onForgeExtensionClick = (0, $42omo.useCallback)((ext)=>{
        experienceTracker.start({
            name: $0c33e41081c1500e$var$EXPERIENCE_NAME,
            id: ext.id,
            timeout: 10000
        });
        showExtension(ext);
        setLoading(true);
    }, [
        showExtension,
        setLoading,
        experienceTracker
    ]);
    // shows up when preloaded in SSR. Shows up again when SPA takes over bf all queries are loaded.
    const LazyLoader = (0, $42omo.useMemo)(()=>(0, $dizL5.lazyForgeUIExtensionsWithLoader)(()=>lazyLoaderPlaceholderComponent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9MrOn.ContentToolsButton // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
            ), {
                isDisabled: !(window.__SSR_RENDERED__ || undefined)
            })), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $42omo.Fragment), null, loadExtension && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$ForgeUIExtensionLoader, {
        extension: extension,
        contentId: contentId,
        spaceKey: spaceKey,
        onLoadComplete: onLoadCompleteCB,
        onClose: onCloseCB
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(LazyLoader, {
        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
        render: (extensions, loading, error)=>{
            if (loading) return children([]);
            if (error) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(error)) (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).ECOSYSTEM
                });
                return children([]);
            }
            const result = extensions.map((ext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ced39bfea5ef5993$export$9f275aff884e1431), {
                    key: ext.id,
                    extension: ext,
                    onClick: onForgeExtensionClick,
                    isLoading: extension === ext
                }));
            return children(result);
        }
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0c33e41081c1500e$var$InvisibleDiv = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_1e0cglyw",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     * LazyForgeUIExtension has its own loading spinner, however, we don't want to show it anywhere. We want to show a
     * loading spinner inside the menu item while loading the extension, and then close the menu once the loading is complete.
     * To accomplish that, we're rendering LazyForgeUIExtension inside an invisible div.
     * @param forgeExtension To be loaded.
     * @param contentId Passed down to ForgeUIExtension both contentId and spaceKey becomes available in the forge app with
     * `useProductContext` hook. For reference https://developer.atlassian.com/platform/forge/ui-hooks-reference/.
     * @param spaceKey Passed down to ForgeUIExtension.
     * @param onLoadComplete Triggered when the forge extension is loaded.
     * @param onClose Triggered when the rendered ModalDialog is closed. (Currently ContentAction forge component can only contain a ModalDialog)
     * @returns LazyForgeUIExtension inside an InvisibleDiv.
     * @constructor
     */ 
function $0c33e41081c1500e$var$ForgeUIExtensionLoader(t0) {
    const $ = (0, $frIzR.c)(33);
    const { extension: extension, contentId: contentId, spaceKey: spaceAlias, onLoadComplete: onLoadComplete, onClose: onClose } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t1] = (0, $ep3mz.usePageState)();
    const { routeName: routeName } = t1;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const { setIsCloseMenuDisabled: setIsCloseMenuDisabled } = (0, $c54hr.useMoreActionsMenuActions)();
    let t2;
    let t3;
    if ($[0] !== setIsCloseMenuDisabled) {
        t2 = ()=>{
            setIsCloseMenuDisabled(true);
            return ()=>{
                setIsCloseMenuDisabled(false);
            };
        };
        t3 = [
            setIsCloseMenuDisabled
        ];
        $[0] = setIsCloseMenuDisabled;
        $[1] = t2;
        $[2] = t3;
    } else {
        t2 = $[1];
        t3 = $[2];
    }
    (0, $42omo.useEffect)(t2, t3);
    let t4;
    if ($[3] !== activationId || $[4] !== contentId || $[5] !== createAnalyticsEvent || $[6] !== experienceTracker || $[7] !== extension || $[8] !== onLoadComplete || $[9] !== routeName || $[10] !== spaceAlias || $[11] !== spaceId) {
        t4 = ()=>{
            experienceTracker.succeed({
                name: $0c33e41081c1500e$var$EXPERIENCE_NAME
            });
            onLoadComplete();
            const appId = (0, $8a9Dm.getAppId)(extension);
            const analyticEvent = createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
                        moduleKey: (0, $8a9Dm.getModuleKey)(extension),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            });
            analyticEvent.fire();
        };
        $[3] = activationId;
        $[4] = contentId;
        $[5] = createAnalyticsEvent;
        $[6] = experienceTracker;
        $[7] = extension;
        $[8] = onLoadComplete;
        $[9] = routeName;
        $[10] = spaceAlias;
        $[11] = spaceId;
        $[12] = t4;
    } else t4 = $[12];
    const onInitialRender = t4;
    if (!spaceKey) return null;
    const t5 = extension.id;
    const t6 = isLivePage ? "live" : null;
    let t7;
    if ($[13] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[13] = routeName;
        $[14] = t7;
    } else t7 = $[14];
    let t8;
    if ($[15] !== contentId || $[16] !== t6 || $[17] !== t7) {
        t8 = {
            id: contentId,
            subtype: t6,
            type: t7
        };
        $[15] = contentId;
        $[16] = t6;
        $[17] = t7;
        $[18] = t8;
    } else t8 = $[18];
    const t9 = spaceKey || spaceAlias;
    let t10;
    if ($[19] !== spaceId || $[20] !== t9) {
        t10 = {
            key: t9,
            id: spaceId
        };
        $[19] = spaceId;
        $[20] = t9;
        $[21] = t10;
    } else t10 = $[21];
    let t11;
    if ($[22] !== t10 || $[23] !== t8) {
        t11 = {
            type: (0, $7Ndnw.FORGE_MODULE_CONTENT_ACTION),
            content: t8,
            space: t10
        };
        $[22] = t10;
        $[23] = t8;
        $[24] = t11;
    } else t11 = $[24];
    let t12;
    if ($[25] !== onClose || $[26] !== setIsCloseMenuDisabled) {
        t12 = ()=>{
            setIsCloseMenuDisabled(false);
            onClose();
        };
        $[25] = onClose;
        $[26] = setIsCloseMenuDisabled;
        $[27] = t12;
    } else t12 = $[27];
    let t13;
    if ($[28] !== extension || $[29] !== onInitialRender || $[30] !== t11 || $[31] !== t12) {
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($0c33e41081c1500e$var$InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7QUD1.ContentActionForgeApp), {
            key: t5,
            app: extension,
            extensionData: t11,
            onInitialRender: onInitialRender,
            onTearDown: t12
        }));
        $[28] = extension;
        $[29] = onInitialRender;
        $[30] = t11;
        $[31] = t12;
        $[32] = t13;
    } else t13 = $[32];
    return t13;
}
$0c33e41081c1500e$var$ForgeUIExtensionLoader.propTypes = {
    extension: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
    contentId: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    spaceKey: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
    onLoadComplete: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
};
module.exports["ForgeContentTools"] = $0c33e41081c1500e$export$7cf22b806dbb23cb;

});

parcelRegister("7Ndnw", function(module, exports) {
const $af2b0e533822f413$export$77aa6bcc53373193 = 'confluence:contentBylineItem';
const $af2b0e533822f413$export$dfd79dc5aae7414d = 'confluence:contextMenu';
const $af2b0e533822f413$export$93827e7f1bb6974c = 'confluence:contentAction';
const $af2b0e533822f413$export$6a8e7521883fbbdb = 'confluence:fullPage';
const $af2b0e533822f413$export$931827627b89a6ba = 'confluence:globalPage';
const $af2b0e533822f413$export$109ae14a8174901f = 'confluence:globalSettings';
const $af2b0e533822f413$export$e31530da5c277984 = 'confluence:homepageFeed';
const $af2b0e533822f413$export$54edc26d40e1a8eb = 'confluence:pageBanner';
const $af2b0e533822f413$export$75695e15f2aab495 = 'confluence:spacePage';
const $af2b0e533822f413$export$f17386882264cfae = 'confluence:spaceSettings';
const $af2b0e533822f413$export$3e9f3e416c5066aa = 'confluence:customContent';
const $af2b0e533822f413$export$b9c5c98eb97dff92 = 'confluence:backgroundScript';
const $af2b0e533822f413$export$c0df8ab57c5edc2a = 'test:module';
const $af2b0e533822f413$export$769f3a278705a683 = 'xen:macro';
const $af2b0e533822f413$export$492ceb220fc48ad2 = [
    $af2b0e533822f413$export$6a8e7521883fbbdb,
    $af2b0e533822f413$export$931827627b89a6ba,
    $af2b0e533822f413$export$109ae14a8174901f,
    $af2b0e533822f413$export$e31530da5c277984,
    $af2b0e533822f413$export$b9c5c98eb97dff92
];
const $af2b0e533822f413$export$ec6cdf0e930aca0a = [
    $af2b0e533822f413$export$75695e15f2aab495,
    $af2b0e533822f413$export$f17386882264cfae,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
const $af2b0e533822f413$export$344b997b63ff6612 = [
    $af2b0e533822f413$export$77aa6bcc53373193,
    $af2b0e533822f413$export$dfd79dc5aae7414d,
    $af2b0e533822f413$export$93827e7f1bb6974c,
    $af2b0e533822f413$export$3e9f3e416c5066aa
];
module.exports["FORGE_MODULE_BYLINE"] = $af2b0e533822f413$export$77aa6bcc53373193;
module.exports["FORGE_MODULE_CONTEXT_MENU"] = $af2b0e533822f413$export$dfd79dc5aae7414d;
module.exports["FORGE_MODULE_CONTENT_ACTION"] = $af2b0e533822f413$export$93827e7f1bb6974c;
module.exports["FORGE_MODULE_GLOBAL_PAGE"] = $af2b0e533822f413$export$931827627b89a6ba;
module.exports["FORGE_MODULE_GLOBAL_SETTINGS"] = $af2b0e533822f413$export$109ae14a8174901f;
module.exports["FORGE_MODULE_HOMEPAGE_FEED"] = $af2b0e533822f413$export$e31530da5c277984;
module.exports["FORGE_MODULE_PAGE_BANNER"] = $af2b0e533822f413$export$54edc26d40e1a8eb;
module.exports["FORGE_MODULE_SPACE_PAGE"] = $af2b0e533822f413$export$75695e15f2aab495;
module.exports["FORGE_MODULE_SPACE_SETTINGS"] = $af2b0e533822f413$export$f17386882264cfae;
module.exports["FORGE_MODULE_CUSTOM_CONTENT"] = $af2b0e533822f413$export$3e9f3e416c5066aa;
module.exports["FORGE_MODULE_BACKGROUND_SCRIPT"] = $af2b0e533822f413$export$b9c5c98eb97dff92;
module.exports["FORGE_MODULE_XEN_MACRO"] = $af2b0e533822f413$export$769f3a278705a683;

});

parcelRegister("7QUD1", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $02976f123c8f8e25$export$d2159b9f3f077903 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "cPPBg",
    name: "ByLineForgeApp",
    loader: async ()=>(await (parcelRequire("lKhER"))).ByLineForgeApp
});

const $02976f123c8f8e25$export$f900958ce7c4410f = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "uUYc7",
    name: "ContentActionForgeApp",
    loader: async ()=>(await (parcelRequire("kTstC"))).ContentActionForgeApp
});

const $02976f123c8f8e25$export$79ed117743c6c2cf = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "YSsGA",
    name: "ContextMenuForgeApp",
    loader: async ()=>(await (parcelRequire("hp3ei"))).ContextMenuForgeApp
});

const $02976f123c8f8e25$export$b8ad4f58faf0ae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "AI3JE",
    name: "FullPageForgeApp",
    loader: async ()=>(await (parcelRequire("c3aTU"))).FullPageForgeApp
});

const $02976f123c8f8e25$export$83db8797814193a8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "HPVuo",
    name: "GlobalPageForgeApp",
    loader: async ()=>(await (parcelRequire("lLC56"))).GlobalPageForgeApp
});

const $02976f123c8f8e25$export$74528162c4c3828b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iEsk7",
    name: "GlobalSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("7hoK8"))).GlobalSettingsForgeApp
});

const $02976f123c8f8e25$export$c8291e2d6d6adbf2 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "MWvHM",
    name: "HomepageFeedForgeApp",
    loader: async ()=>(await (parcelRequire("hUSae"))).HomepageFeedForgeApp
});

const $02976f123c8f8e25$export$e8858129e933f7e8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "KHgoO",
    name: "SpaceSettingsForgeApp",
    loader: async ()=>(await (parcelRequire("fJu5o"))).SpaceSettingsForgeApp
});

const $02976f123c8f8e25$export$60a905140138a1c8 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "-3RXI",
    name: "SpacePageForgeApp",
    loader: async ()=>(await (parcelRequire("aFWc8"))).SpacePageForgeApp
});

const $02976f123c8f8e25$export$578d0cbdb0ffa72e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9Auod",
    name: "CustomContentForgeApp",
    loader: async ()=>(await (parcelRequire("dLqX4"))).CustomContentForgeApp
});

const $02976f123c8f8e25$export$40d4b5cfa6c18ea7 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "zkdSh",
    name: "BackgroundScriptForgeApp",
    loader: async ()=>(await (parcelRequire("i63Fz"))).BackgroundScriptForgeApp
});

const $02976f123c8f8e25$export$c76787f94e0b1609 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "BA7en",
    name: "PageBannerForgeApp",
    loader: async ()=>(await (parcelRequire("4ddcJ"))).PageBannerForgeApp
});
module.exports["ByLineForgeApp"] = $02976f123c8f8e25$export$d2159b9f3f077903;
module.exports["ContentActionForgeApp"] = $02976f123c8f8e25$export$f900958ce7c4410f;
module.exports["ContextMenuForgeApp"] = $02976f123c8f8e25$export$79ed117743c6c2cf;
module.exports["GlobalPageForgeApp"] = $02976f123c8f8e25$export$83db8797814193a8;
module.exports["GlobalSettingsForgeApp"] = $02976f123c8f8e25$export$74528162c4c3828b;
module.exports["HomepageFeedForgeApp"] = $02976f123c8f8e25$export$c8291e2d6d6adbf2;
module.exports["SpaceSettingsForgeApp"] = $02976f123c8f8e25$export$e8858129e933f7e8;
module.exports["SpacePageForgeApp"] = $02976f123c8f8e25$export$60a905140138a1c8;
module.exports["CustomContentForgeApp"] = $02976f123c8f8e25$export$578d0cbdb0ffa72e;
module.exports["BackgroundScriptForgeApp"] = $02976f123c8f8e25$export$40d4b5cfa6c18ea7;
module.exports["PageBannerForgeApp"] = $02976f123c8f8e25$export$c76787f94e0b1609;

});

parcelRegister("lKhER", function(module, exports) {

let $fd4b975c2e57b4af$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd4b975c2e57b4af$var$load("2YffH"),
    $fd4b975c2e57b4af$var$load("8Kivm"),
    $fd4b975c2e57b4af$var$load("dEFLb"),
    $fd4b975c2e57b4af$var$load("lqFMg"),
    $fd4b975c2e57b4af$var$load("aT7sf"),
    $fd4b975c2e57b4af$var$load("fRvqe"),
    $fd4b975c2e57b4af$var$load("iQ0Jm"),
    $fd4b975c2e57b4af$var$load("6lUA3"),
    $fd4b975c2e57b4af$var$load("8Tr2S"),
    $fd4b975c2e57b4af$var$load("eBRUf"),
    $fd4b975c2e57b4af$var$load("b6cAi"),
    $fd4b975c2e57b4af$var$load("41B44"),
    $fd4b975c2e57b4af$var$load("h4Nf7"),
    $fd4b975c2e57b4af$var$load("7f9Fz"),
    $fd4b975c2e57b4af$var$load("8YSo7"),
    $fd4b975c2e57b4af$var$load("aowzi"),
    $fd4b975c2e57b4af$var$load("7PE6o"),
    $fd4b975c2e57b4af$var$load("lXGg9"),
    $fd4b975c2e57b4af$var$load("hy3sK"),
    $fd4b975c2e57b4af$var$load("g9CVe"),
    $fd4b975c2e57b4af$var$load("aeEUI"),
    $fd4b975c2e57b4af$var$load("eY3St"),
    $fd4b975c2e57b4af$var$load("bkd4T"),
    $fd4b975c2e57b4af$var$load("6wr18"),
    $fd4b975c2e57b4af$var$load("kjZZD"),
    $fd4b975c2e57b4af$var$load("Wowvf"),
    $fd4b975c2e57b4af$var$load("kHOMt"),
    $fd4b975c2e57b4af$var$load("dRpV3"),
    $fd4b975c2e57b4af$var$load("ffEVr"),
    $fd4b975c2e57b4af$var$load("hhss7"),
    $fd4b975c2e57b4af$var$load("20dNF"),
    $fd4b975c2e57b4af$var$load("1zt4N"),
    $fd4b975c2e57b4af$var$load("8lj0L"),
    $fd4b975c2e57b4af$var$load("eUy1m"),
    $fd4b975c2e57b4af$var$load("3yFw0"),
    $fd4b975c2e57b4af$var$load("jryxA"),
    $fd4b975c2e57b4af$var$load("dWZbK"),
    $fd4b975c2e57b4af$var$load("iqKwT"),
    $fd4b975c2e57b4af$var$load("kULV9"),
    $fd4b975c2e57b4af$var$load("jEmf3"),
    $fd4b975c2e57b4af$var$load("kUbUu"),
    $fd4b975c2e57b4af$var$load("2PePB"),
    $fd4b975c2e57b4af$var$load("lnKog"),
    $fd4b975c2e57b4af$var$load("9ftJe"),
    $fd4b975c2e57b4af$var$load("euYY7"),
    $fd4b975c2e57b4af$var$load("kC80R"),
    $fd4b975c2e57b4af$var$load("7EorR"),
    $fd4b975c2e57b4af$var$load("bGzhS")
]).then(()=>parcelRequire('5soYL'));

});

parcelRegister("kTstC", function(module, exports) {

let $03ece33c1f185f23$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $03ece33c1f185f23$var$load("2YffH"),
    $03ece33c1f185f23$var$load("8Kivm"),
    $03ece33c1f185f23$var$load("dEFLb"),
    $03ece33c1f185f23$var$load("lqFMg"),
    $03ece33c1f185f23$var$load("aT7sf"),
    $03ece33c1f185f23$var$load("fRvqe"),
    $03ece33c1f185f23$var$load("iQ0Jm"),
    $03ece33c1f185f23$var$load("6lUA3"),
    $03ece33c1f185f23$var$load("8Tr2S"),
    $03ece33c1f185f23$var$load("eBRUf"),
    $03ece33c1f185f23$var$load("b6cAi"),
    $03ece33c1f185f23$var$load("41B44"),
    $03ece33c1f185f23$var$load("h4Nf7"),
    $03ece33c1f185f23$var$load("7f9Fz"),
    $03ece33c1f185f23$var$load("8YSo7"),
    $03ece33c1f185f23$var$load("aowzi"),
    $03ece33c1f185f23$var$load("7PE6o"),
    $03ece33c1f185f23$var$load("lXGg9"),
    $03ece33c1f185f23$var$load("hy3sK"),
    $03ece33c1f185f23$var$load("g9CVe"),
    $03ece33c1f185f23$var$load("aeEUI"),
    $03ece33c1f185f23$var$load("eY3St"),
    $03ece33c1f185f23$var$load("bkd4T"),
    $03ece33c1f185f23$var$load("6wr18"),
    $03ece33c1f185f23$var$load("kjZZD"),
    $03ece33c1f185f23$var$load("Wowvf"),
    $03ece33c1f185f23$var$load("kHOMt"),
    $03ece33c1f185f23$var$load("dRpV3"),
    $03ece33c1f185f23$var$load("ffEVr"),
    $03ece33c1f185f23$var$load("hhss7"),
    $03ece33c1f185f23$var$load("20dNF"),
    $03ece33c1f185f23$var$load("1zt4N"),
    $03ece33c1f185f23$var$load("8lj0L"),
    $03ece33c1f185f23$var$load("eUy1m"),
    $03ece33c1f185f23$var$load("3yFw0"),
    $03ece33c1f185f23$var$load("jryxA"),
    $03ece33c1f185f23$var$load("dWZbK"),
    $03ece33c1f185f23$var$load("iqKwT"),
    $03ece33c1f185f23$var$load("kULV9"),
    $03ece33c1f185f23$var$load("jEmf3"),
    $03ece33c1f185f23$var$load("kUbUu"),
    $03ece33c1f185f23$var$load("2PePB"),
    $03ece33c1f185f23$var$load("lnKog"),
    $03ece33c1f185f23$var$load("9ftJe"),
    $03ece33c1f185f23$var$load("euYY7"),
    $03ece33c1f185f23$var$load("kC80R"),
    $03ece33c1f185f23$var$load("7EorR"),
    $03ece33c1f185f23$var$load("bdzih")
]).then(()=>parcelRequire('kXBs1'));

});

parcelRegister("hp3ei", function(module, exports) {

let $cab746cf65a7f1c2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cab746cf65a7f1c2$var$load("2YffH"),
    $cab746cf65a7f1c2$var$load("8Kivm"),
    $cab746cf65a7f1c2$var$load("dEFLb"),
    $cab746cf65a7f1c2$var$load("lqFMg"),
    $cab746cf65a7f1c2$var$load("aT7sf"),
    $cab746cf65a7f1c2$var$load("fRvqe"),
    $cab746cf65a7f1c2$var$load("iQ0Jm"),
    $cab746cf65a7f1c2$var$load("6lUA3"),
    $cab746cf65a7f1c2$var$load("8Tr2S"),
    $cab746cf65a7f1c2$var$load("eBRUf"),
    $cab746cf65a7f1c2$var$load("b6cAi"),
    $cab746cf65a7f1c2$var$load("41B44"),
    $cab746cf65a7f1c2$var$load("h4Nf7"),
    $cab746cf65a7f1c2$var$load("7f9Fz"),
    $cab746cf65a7f1c2$var$load("8YSo7"),
    $cab746cf65a7f1c2$var$load("aowzi"),
    $cab746cf65a7f1c2$var$load("7PE6o"),
    $cab746cf65a7f1c2$var$load("lXGg9"),
    $cab746cf65a7f1c2$var$load("hy3sK"),
    $cab746cf65a7f1c2$var$load("g9CVe"),
    $cab746cf65a7f1c2$var$load("aeEUI"),
    $cab746cf65a7f1c2$var$load("eY3St"),
    $cab746cf65a7f1c2$var$load("bkd4T"),
    $cab746cf65a7f1c2$var$load("6wr18"),
    $cab746cf65a7f1c2$var$load("kjZZD"),
    $cab746cf65a7f1c2$var$load("Wowvf"),
    $cab746cf65a7f1c2$var$load("kHOMt"),
    $cab746cf65a7f1c2$var$load("dRpV3"),
    $cab746cf65a7f1c2$var$load("ffEVr"),
    $cab746cf65a7f1c2$var$load("hhss7"),
    $cab746cf65a7f1c2$var$load("20dNF"),
    $cab746cf65a7f1c2$var$load("1zt4N"),
    $cab746cf65a7f1c2$var$load("8lj0L"),
    $cab746cf65a7f1c2$var$load("eUy1m"),
    $cab746cf65a7f1c2$var$load("3yFw0"),
    $cab746cf65a7f1c2$var$load("jryxA"),
    $cab746cf65a7f1c2$var$load("dWZbK"),
    $cab746cf65a7f1c2$var$load("iqKwT"),
    $cab746cf65a7f1c2$var$load("kULV9"),
    $cab746cf65a7f1c2$var$load("jEmf3"),
    $cab746cf65a7f1c2$var$load("kUbUu"),
    $cab746cf65a7f1c2$var$load("2PePB"),
    $cab746cf65a7f1c2$var$load("lnKog"),
    $cab746cf65a7f1c2$var$load("9ftJe"),
    $cab746cf65a7f1c2$var$load("euYY7"),
    $cab746cf65a7f1c2$var$load("kC80R"),
    $cab746cf65a7f1c2$var$load("7EorR"),
    $cab746cf65a7f1c2$var$load("cwpVK")
]).then(()=>parcelRequire('1yxl3'));

});

parcelRegister("c3aTU", function(module, exports) {

let $8c5e38873afc7b40$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8c5e38873afc7b40$var$load("lXGg9"),
    $8c5e38873afc7b40$var$load("hy3sK"),
    $8c5e38873afc7b40$var$load("2YffH"),
    $8c5e38873afc7b40$var$load("dEFLb"),
    $8c5e38873afc7b40$var$load("lqFMg"),
    $8c5e38873afc7b40$var$load("2PePB"),
    $8c5e38873afc7b40$var$load("aT7sf"),
    $8c5e38873afc7b40$var$load("fRvqe"),
    $8c5e38873afc7b40$var$load("6lUA3"),
    $8c5e38873afc7b40$var$load("eBRUf"),
    $8c5e38873afc7b40$var$load("b6cAi"),
    $8c5e38873afc7b40$var$load("41B44"),
    $8c5e38873afc7b40$var$load("h4Nf7"),
    $8c5e38873afc7b40$var$load("7f9Fz"),
    $8c5e38873afc7b40$var$load("8YSo7"),
    $8c5e38873afc7b40$var$load("aowzi"),
    $8c5e38873afc7b40$var$load("7PE6o"),
    $8c5e38873afc7b40$var$load("g9CVe"),
    $8c5e38873afc7b40$var$load("aeEUI"),
    $8c5e38873afc7b40$var$load("eY3St"),
    $8c5e38873afc7b40$var$load("bkd4T"),
    $8c5e38873afc7b40$var$load("6wr18"),
    $8c5e38873afc7b40$var$load("kjZZD"),
    $8c5e38873afc7b40$var$load("Wowvf"),
    $8c5e38873afc7b40$var$load("kHOMt"),
    $8c5e38873afc7b40$var$load("dRpV3"),
    $8c5e38873afc7b40$var$load("ffEVr"),
    $8c5e38873afc7b40$var$load("hhss7"),
    $8c5e38873afc7b40$var$load("20dNF"),
    $8c5e38873afc7b40$var$load("1zt4N"),
    $8c5e38873afc7b40$var$load("8lj0L"),
    $8c5e38873afc7b40$var$load("eUy1m"),
    $8c5e38873afc7b40$var$load("3yFw0"),
    $8c5e38873afc7b40$var$load("jryxA"),
    $8c5e38873afc7b40$var$load("dWZbK"),
    $8c5e38873afc7b40$var$load("iqKwT"),
    $8c5e38873afc7b40$var$load("kULV9"),
    $8c5e38873afc7b40$var$load("jEmf3"),
    $8c5e38873afc7b40$var$load("kUbUu"),
    $8c5e38873afc7b40$var$load("9ftJe"),
    $8c5e38873afc7b40$var$load("euYY7"),
    $8c5e38873afc7b40$var$load("kC80R"),
    $8c5e38873afc7b40$var$load("7EorR"),
    $8c5e38873afc7b40$var$load("68RC4")
]).then(()=>parcelRequire('f6dwD'));

});

parcelRegister("lLC56", function(module, exports) {

let $fd8b86e94859c2e3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $fd8b86e94859c2e3$var$load("lXGg9"),
    $fd8b86e94859c2e3$var$load("hy3sK"),
    $fd8b86e94859c2e3$var$load("2YffH"),
    $fd8b86e94859c2e3$var$load("dEFLb"),
    $fd8b86e94859c2e3$var$load("lqFMg"),
    $fd8b86e94859c2e3$var$load("2PePB"),
    $fd8b86e94859c2e3$var$load("aT7sf"),
    $fd8b86e94859c2e3$var$load("fRvqe"),
    $fd8b86e94859c2e3$var$load("6lUA3"),
    $fd8b86e94859c2e3$var$load("eBRUf"),
    $fd8b86e94859c2e3$var$load("b6cAi"),
    $fd8b86e94859c2e3$var$load("41B44"),
    $fd8b86e94859c2e3$var$load("h4Nf7"),
    $fd8b86e94859c2e3$var$load("7f9Fz"),
    $fd8b86e94859c2e3$var$load("8YSo7"),
    $fd8b86e94859c2e3$var$load("aowzi"),
    $fd8b86e94859c2e3$var$load("7PE6o"),
    $fd8b86e94859c2e3$var$load("g9CVe"),
    $fd8b86e94859c2e3$var$load("aeEUI"),
    $fd8b86e94859c2e3$var$load("eY3St"),
    $fd8b86e94859c2e3$var$load("bkd4T"),
    $fd8b86e94859c2e3$var$load("6wr18"),
    $fd8b86e94859c2e3$var$load("kjZZD"),
    $fd8b86e94859c2e3$var$load("Wowvf"),
    $fd8b86e94859c2e3$var$load("kHOMt"),
    $fd8b86e94859c2e3$var$load("dRpV3"),
    $fd8b86e94859c2e3$var$load("ffEVr"),
    $fd8b86e94859c2e3$var$load("hhss7"),
    $fd8b86e94859c2e3$var$load("20dNF"),
    $fd8b86e94859c2e3$var$load("1zt4N"),
    $fd8b86e94859c2e3$var$load("8lj0L"),
    $fd8b86e94859c2e3$var$load("eUy1m"),
    $fd8b86e94859c2e3$var$load("3yFw0"),
    $fd8b86e94859c2e3$var$load("jryxA"),
    $fd8b86e94859c2e3$var$load("dWZbK"),
    $fd8b86e94859c2e3$var$load("iqKwT"),
    $fd8b86e94859c2e3$var$load("kULV9"),
    $fd8b86e94859c2e3$var$load("jEmf3"),
    $fd8b86e94859c2e3$var$load("kUbUu"),
    $fd8b86e94859c2e3$var$load("9ftJe"),
    $fd8b86e94859c2e3$var$load("euYY7"),
    $fd8b86e94859c2e3$var$load("kC80R"),
    $fd8b86e94859c2e3$var$load("7EorR"),
    $fd8b86e94859c2e3$var$load("87cDu")
]).then(()=>parcelRequire('iChZx'));

});

parcelRegister("7hoK8", function(module, exports) {

let $54cd506a596cf063$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $54cd506a596cf063$var$load("lXGg9"),
    $54cd506a596cf063$var$load("hy3sK"),
    $54cd506a596cf063$var$load("2YffH"),
    $54cd506a596cf063$var$load("dEFLb"),
    $54cd506a596cf063$var$load("lqFMg"),
    $54cd506a596cf063$var$load("2PePB"),
    $54cd506a596cf063$var$load("aT7sf"),
    $54cd506a596cf063$var$load("fRvqe"),
    $54cd506a596cf063$var$load("6lUA3"),
    $54cd506a596cf063$var$load("eBRUf"),
    $54cd506a596cf063$var$load("b6cAi"),
    $54cd506a596cf063$var$load("41B44"),
    $54cd506a596cf063$var$load("h4Nf7"),
    $54cd506a596cf063$var$load("7f9Fz"),
    $54cd506a596cf063$var$load("8YSo7"),
    $54cd506a596cf063$var$load("aowzi"),
    $54cd506a596cf063$var$load("7PE6o"),
    $54cd506a596cf063$var$load("g9CVe"),
    $54cd506a596cf063$var$load("aeEUI"),
    $54cd506a596cf063$var$load("eY3St"),
    $54cd506a596cf063$var$load("bkd4T"),
    $54cd506a596cf063$var$load("6wr18"),
    $54cd506a596cf063$var$load("kjZZD"),
    $54cd506a596cf063$var$load("Wowvf"),
    $54cd506a596cf063$var$load("kHOMt"),
    $54cd506a596cf063$var$load("dRpV3"),
    $54cd506a596cf063$var$load("ffEVr"),
    $54cd506a596cf063$var$load("hhss7"),
    $54cd506a596cf063$var$load("20dNF"),
    $54cd506a596cf063$var$load("1zt4N"),
    $54cd506a596cf063$var$load("8lj0L"),
    $54cd506a596cf063$var$load("eUy1m"),
    $54cd506a596cf063$var$load("3yFw0"),
    $54cd506a596cf063$var$load("jryxA"),
    $54cd506a596cf063$var$load("dWZbK"),
    $54cd506a596cf063$var$load("iqKwT"),
    $54cd506a596cf063$var$load("kULV9"),
    $54cd506a596cf063$var$load("jEmf3"),
    $54cd506a596cf063$var$load("kUbUu"),
    $54cd506a596cf063$var$load("9ftJe"),
    $54cd506a596cf063$var$load("euYY7"),
    $54cd506a596cf063$var$load("kC80R"),
    $54cd506a596cf063$var$load("7EorR"),
    $54cd506a596cf063$var$load("iXr0W")
]).then(()=>parcelRequire('671JL'));

});

parcelRegister("hUSae", function(module, exports) {

let $d0b1ae745eaa5d2a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d0b1ae745eaa5d2a$var$load("lXGg9"),
    $d0b1ae745eaa5d2a$var$load("hy3sK"),
    $d0b1ae745eaa5d2a$var$load("2YffH"),
    $d0b1ae745eaa5d2a$var$load("dEFLb"),
    $d0b1ae745eaa5d2a$var$load("lqFMg"),
    $d0b1ae745eaa5d2a$var$load("aT7sf"),
    $d0b1ae745eaa5d2a$var$load("fRvqe"),
    $d0b1ae745eaa5d2a$var$load("6lUA3"),
    $d0b1ae745eaa5d2a$var$load("eBRUf"),
    $d0b1ae745eaa5d2a$var$load("b6cAi"),
    $d0b1ae745eaa5d2a$var$load("41B44"),
    $d0b1ae745eaa5d2a$var$load("h4Nf7"),
    $d0b1ae745eaa5d2a$var$load("7f9Fz"),
    $d0b1ae745eaa5d2a$var$load("8YSo7"),
    $d0b1ae745eaa5d2a$var$load("aowzi"),
    $d0b1ae745eaa5d2a$var$load("7PE6o"),
    $d0b1ae745eaa5d2a$var$load("g9CVe"),
    $d0b1ae745eaa5d2a$var$load("aeEUI"),
    $d0b1ae745eaa5d2a$var$load("eY3St"),
    $d0b1ae745eaa5d2a$var$load("bkd4T"),
    $d0b1ae745eaa5d2a$var$load("6wr18"),
    $d0b1ae745eaa5d2a$var$load("kjZZD"),
    $d0b1ae745eaa5d2a$var$load("Wowvf"),
    $d0b1ae745eaa5d2a$var$load("kHOMt"),
    $d0b1ae745eaa5d2a$var$load("dRpV3"),
    $d0b1ae745eaa5d2a$var$load("ffEVr"),
    $d0b1ae745eaa5d2a$var$load("hhss7"),
    $d0b1ae745eaa5d2a$var$load("20dNF"),
    $d0b1ae745eaa5d2a$var$load("1zt4N"),
    $d0b1ae745eaa5d2a$var$load("8lj0L"),
    $d0b1ae745eaa5d2a$var$load("eUy1m"),
    $d0b1ae745eaa5d2a$var$load("3yFw0"),
    $d0b1ae745eaa5d2a$var$load("jryxA"),
    $d0b1ae745eaa5d2a$var$load("dWZbK"),
    $d0b1ae745eaa5d2a$var$load("iqKwT"),
    $d0b1ae745eaa5d2a$var$load("kULV9"),
    $d0b1ae745eaa5d2a$var$load("jEmf3"),
    $d0b1ae745eaa5d2a$var$load("kUbUu"),
    $d0b1ae745eaa5d2a$var$load("2PePB"),
    $d0b1ae745eaa5d2a$var$load("lnKog"),
    $d0b1ae745eaa5d2a$var$load("9ftJe"),
    $d0b1ae745eaa5d2a$var$load("euYY7"),
    $d0b1ae745eaa5d2a$var$load("kC80R"),
    $d0b1ae745eaa5d2a$var$load("7EorR"),
    $d0b1ae745eaa5d2a$var$load("ccJug")
]).then(()=>parcelRequire('k3MMo'));

});

parcelRegister("fJu5o", function(module, exports) {

let $b742656a0ea664bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b742656a0ea664bd$var$load("2YffH"),
    $b742656a0ea664bd$var$load("dEFLb"),
    $b742656a0ea664bd$var$load("lqFMg"),
    $b742656a0ea664bd$var$load("aT7sf"),
    $b742656a0ea664bd$var$load("fRvqe"),
    $b742656a0ea664bd$var$load("6lUA3"),
    $b742656a0ea664bd$var$load("8Tr2S"),
    $b742656a0ea664bd$var$load("eBRUf"),
    $b742656a0ea664bd$var$load("b6cAi"),
    $b742656a0ea664bd$var$load("41B44"),
    $b742656a0ea664bd$var$load("h4Nf7"),
    $b742656a0ea664bd$var$load("7f9Fz"),
    $b742656a0ea664bd$var$load("8YSo7"),
    $b742656a0ea664bd$var$load("aowzi"),
    $b742656a0ea664bd$var$load("7PE6o"),
    $b742656a0ea664bd$var$load("lXGg9"),
    $b742656a0ea664bd$var$load("hy3sK"),
    $b742656a0ea664bd$var$load("g9CVe"),
    $b742656a0ea664bd$var$load("aeEUI"),
    $b742656a0ea664bd$var$load("eY3St"),
    $b742656a0ea664bd$var$load("bkd4T"),
    $b742656a0ea664bd$var$load("6wr18"),
    $b742656a0ea664bd$var$load("kjZZD"),
    $b742656a0ea664bd$var$load("Wowvf"),
    $b742656a0ea664bd$var$load("kHOMt"),
    $b742656a0ea664bd$var$load("dRpV3"),
    $b742656a0ea664bd$var$load("ffEVr"),
    $b742656a0ea664bd$var$load("dTsOE"),
    $b742656a0ea664bd$var$load("hhss7"),
    $b742656a0ea664bd$var$load("20dNF"),
    $b742656a0ea664bd$var$load("1zt4N"),
    $b742656a0ea664bd$var$load("8lj0L"),
    $b742656a0ea664bd$var$load("eUy1m"),
    $b742656a0ea664bd$var$load("3yFw0"),
    $b742656a0ea664bd$var$load("jryxA"),
    $b742656a0ea664bd$var$load("dWZbK"),
    $b742656a0ea664bd$var$load("iqKwT"),
    $b742656a0ea664bd$var$load("kULV9"),
    $b742656a0ea664bd$var$load("jEmf3"),
    $b742656a0ea664bd$var$load("kUbUu"),
    $b742656a0ea664bd$var$load("2PePB"),
    $b742656a0ea664bd$var$load("lnKog"),
    $b742656a0ea664bd$var$load("9ftJe"),
    $b742656a0ea664bd$var$load("euYY7"),
    $b742656a0ea664bd$var$load("kC80R"),
    $b742656a0ea664bd$var$load("7EorR"),
    $b742656a0ea664bd$var$load("irYLY")
]).then(()=>parcelRequire('aeos9'));

});

parcelRegister("aFWc8", function(module, exports) {

let $7c5adffc79c46ae0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c5adffc79c46ae0$var$load("2YffH"),
    $7c5adffc79c46ae0$var$load("dEFLb"),
    $7c5adffc79c46ae0$var$load("lqFMg"),
    $7c5adffc79c46ae0$var$load("aT7sf"),
    $7c5adffc79c46ae0$var$load("fRvqe"),
    $7c5adffc79c46ae0$var$load("6lUA3"),
    $7c5adffc79c46ae0$var$load("8Tr2S"),
    $7c5adffc79c46ae0$var$load("eBRUf"),
    $7c5adffc79c46ae0$var$load("b6cAi"),
    $7c5adffc79c46ae0$var$load("41B44"),
    $7c5adffc79c46ae0$var$load("h4Nf7"),
    $7c5adffc79c46ae0$var$load("7f9Fz"),
    $7c5adffc79c46ae0$var$load("8YSo7"),
    $7c5adffc79c46ae0$var$load("aowzi"),
    $7c5adffc79c46ae0$var$load("7PE6o"),
    $7c5adffc79c46ae0$var$load("lXGg9"),
    $7c5adffc79c46ae0$var$load("hy3sK"),
    $7c5adffc79c46ae0$var$load("g9CVe"),
    $7c5adffc79c46ae0$var$load("aeEUI"),
    $7c5adffc79c46ae0$var$load("eY3St"),
    $7c5adffc79c46ae0$var$load("bkd4T"),
    $7c5adffc79c46ae0$var$load("6wr18"),
    $7c5adffc79c46ae0$var$load("kjZZD"),
    $7c5adffc79c46ae0$var$load("Wowvf"),
    $7c5adffc79c46ae0$var$load("kHOMt"),
    $7c5adffc79c46ae0$var$load("dRpV3"),
    $7c5adffc79c46ae0$var$load("ffEVr"),
    $7c5adffc79c46ae0$var$load("dTsOE"),
    $7c5adffc79c46ae0$var$load("hhss7"),
    $7c5adffc79c46ae0$var$load("20dNF"),
    $7c5adffc79c46ae0$var$load("1zt4N"),
    $7c5adffc79c46ae0$var$load("8lj0L"),
    $7c5adffc79c46ae0$var$load("eUy1m"),
    $7c5adffc79c46ae0$var$load("3yFw0"),
    $7c5adffc79c46ae0$var$load("jryxA"),
    $7c5adffc79c46ae0$var$load("dWZbK"),
    $7c5adffc79c46ae0$var$load("iqKwT"),
    $7c5adffc79c46ae0$var$load("kULV9"),
    $7c5adffc79c46ae0$var$load("jEmf3"),
    $7c5adffc79c46ae0$var$load("kUbUu"),
    $7c5adffc79c46ae0$var$load("2PePB"),
    $7c5adffc79c46ae0$var$load("lnKog"),
    $7c5adffc79c46ae0$var$load("9ftJe"),
    $7c5adffc79c46ae0$var$load("euYY7"),
    $7c5adffc79c46ae0$var$load("kC80R"),
    $7c5adffc79c46ae0$var$load("7EorR"),
    $7c5adffc79c46ae0$var$load("ldtPf")
]).then(()=>parcelRequire('kWbxC'));

});

parcelRegister("dLqX4", function(module, exports) {

let $a0549235d1f5b081$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a0549235d1f5b081$var$load("lXGg9"),
    $a0549235d1f5b081$var$load("hy3sK"),
    $a0549235d1f5b081$var$load("2YffH"),
    $a0549235d1f5b081$var$load("dEFLb"),
    $a0549235d1f5b081$var$load("lqFMg"),
    $a0549235d1f5b081$var$load("2PePB"),
    $a0549235d1f5b081$var$load("aT7sf"),
    $a0549235d1f5b081$var$load("fRvqe"),
    $a0549235d1f5b081$var$load("6lUA3"),
    $a0549235d1f5b081$var$load("eBRUf"),
    $a0549235d1f5b081$var$load("b6cAi"),
    $a0549235d1f5b081$var$load("41B44"),
    $a0549235d1f5b081$var$load("h4Nf7"),
    $a0549235d1f5b081$var$load("7f9Fz"),
    $a0549235d1f5b081$var$load("8YSo7"),
    $a0549235d1f5b081$var$load("aowzi"),
    $a0549235d1f5b081$var$load("7PE6o"),
    $a0549235d1f5b081$var$load("g9CVe"),
    $a0549235d1f5b081$var$load("aeEUI"),
    $a0549235d1f5b081$var$load("eY3St"),
    $a0549235d1f5b081$var$load("bkd4T"),
    $a0549235d1f5b081$var$load("6wr18"),
    $a0549235d1f5b081$var$load("kjZZD"),
    $a0549235d1f5b081$var$load("Wowvf"),
    $a0549235d1f5b081$var$load("kHOMt"),
    $a0549235d1f5b081$var$load("dRpV3"),
    $a0549235d1f5b081$var$load("ffEVr"),
    $a0549235d1f5b081$var$load("hhss7"),
    $a0549235d1f5b081$var$load("20dNF"),
    $a0549235d1f5b081$var$load("1zt4N"),
    $a0549235d1f5b081$var$load("8lj0L"),
    $a0549235d1f5b081$var$load("eUy1m"),
    $a0549235d1f5b081$var$load("3yFw0"),
    $a0549235d1f5b081$var$load("jryxA"),
    $a0549235d1f5b081$var$load("dWZbK"),
    $a0549235d1f5b081$var$load("iqKwT"),
    $a0549235d1f5b081$var$load("kULV9"),
    $a0549235d1f5b081$var$load("jEmf3"),
    $a0549235d1f5b081$var$load("kUbUu"),
    $a0549235d1f5b081$var$load("9ftJe"),
    $a0549235d1f5b081$var$load("euYY7"),
    $a0549235d1f5b081$var$load("kC80R"),
    $a0549235d1f5b081$var$load("7EorR"),
    $a0549235d1f5b081$var$load("6wcNV")
]).then(()=>parcelRequire('iMf0a'));

});

parcelRegister("i63Fz", function(module, exports) {

let $d2cba2393e99b5ff$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $d2cba2393e99b5ff$var$load("lXGg9"),
    $d2cba2393e99b5ff$var$load("hy3sK"),
    $d2cba2393e99b5ff$var$load("2YffH"),
    $d2cba2393e99b5ff$var$load("dEFLb"),
    $d2cba2393e99b5ff$var$load("lqFMg"),
    $d2cba2393e99b5ff$var$load("aT7sf"),
    $d2cba2393e99b5ff$var$load("fRvqe"),
    $d2cba2393e99b5ff$var$load("6lUA3"),
    $d2cba2393e99b5ff$var$load("eBRUf"),
    $d2cba2393e99b5ff$var$load("b6cAi"),
    $d2cba2393e99b5ff$var$load("41B44"),
    $d2cba2393e99b5ff$var$load("h4Nf7"),
    $d2cba2393e99b5ff$var$load("7f9Fz"),
    $d2cba2393e99b5ff$var$load("8YSo7"),
    $d2cba2393e99b5ff$var$load("aowzi"),
    $d2cba2393e99b5ff$var$load("7PE6o"),
    $d2cba2393e99b5ff$var$load("g9CVe"),
    $d2cba2393e99b5ff$var$load("aeEUI"),
    $d2cba2393e99b5ff$var$load("eY3St"),
    $d2cba2393e99b5ff$var$load("bkd4T"),
    $d2cba2393e99b5ff$var$load("6wr18"),
    $d2cba2393e99b5ff$var$load("kjZZD"),
    $d2cba2393e99b5ff$var$load("Wowvf"),
    $d2cba2393e99b5ff$var$load("kHOMt"),
    $d2cba2393e99b5ff$var$load("dRpV3"),
    $d2cba2393e99b5ff$var$load("ffEVr"),
    $d2cba2393e99b5ff$var$load("hhss7"),
    $d2cba2393e99b5ff$var$load("20dNF"),
    $d2cba2393e99b5ff$var$load("1zt4N"),
    $d2cba2393e99b5ff$var$load("8lj0L"),
    $d2cba2393e99b5ff$var$load("eUy1m"),
    $d2cba2393e99b5ff$var$load("3yFw0"),
    $d2cba2393e99b5ff$var$load("jryxA"),
    $d2cba2393e99b5ff$var$load("dWZbK"),
    $d2cba2393e99b5ff$var$load("iqKwT"),
    $d2cba2393e99b5ff$var$load("kULV9"),
    $d2cba2393e99b5ff$var$load("jEmf3"),
    $d2cba2393e99b5ff$var$load("kUbUu"),
    $d2cba2393e99b5ff$var$load("2PePB"),
    $d2cba2393e99b5ff$var$load("lnKog"),
    $d2cba2393e99b5ff$var$load("9ftJe"),
    $d2cba2393e99b5ff$var$load("euYY7"),
    $d2cba2393e99b5ff$var$load("kC80R"),
    $d2cba2393e99b5ff$var$load("7EorR"),
    $d2cba2393e99b5ff$var$load("i9jMB")
]).then(()=>parcelRequire('estkk'));

});

parcelRegister("4ddcJ", function(module, exports) {

let $31129e6bc8797155$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $31129e6bc8797155$var$load("lXGg9"),
    $31129e6bc8797155$var$load("hy3sK"),
    $31129e6bc8797155$var$load("2YffH"),
    $31129e6bc8797155$var$load("dEFLb"),
    $31129e6bc8797155$var$load("lqFMg"),
    $31129e6bc8797155$var$load("aT7sf"),
    $31129e6bc8797155$var$load("fRvqe"),
    $31129e6bc8797155$var$load("6lUA3"),
    $31129e6bc8797155$var$load("eBRUf"),
    $31129e6bc8797155$var$load("b6cAi"),
    $31129e6bc8797155$var$load("41B44"),
    $31129e6bc8797155$var$load("h4Nf7"),
    $31129e6bc8797155$var$load("7f9Fz"),
    $31129e6bc8797155$var$load("8YSo7"),
    $31129e6bc8797155$var$load("aowzi"),
    $31129e6bc8797155$var$load("7PE6o"),
    $31129e6bc8797155$var$load("g9CVe"),
    $31129e6bc8797155$var$load("aeEUI"),
    $31129e6bc8797155$var$load("eY3St"),
    $31129e6bc8797155$var$load("bkd4T"),
    $31129e6bc8797155$var$load("6wr18"),
    $31129e6bc8797155$var$load("kjZZD"),
    $31129e6bc8797155$var$load("Wowvf"),
    $31129e6bc8797155$var$load("kHOMt"),
    $31129e6bc8797155$var$load("dRpV3"),
    $31129e6bc8797155$var$load("ffEVr"),
    $31129e6bc8797155$var$load("hhss7"),
    $31129e6bc8797155$var$load("20dNF"),
    $31129e6bc8797155$var$load("1zt4N"),
    $31129e6bc8797155$var$load("8lj0L"),
    $31129e6bc8797155$var$load("eUy1m"),
    $31129e6bc8797155$var$load("3yFw0"),
    $31129e6bc8797155$var$load("jryxA"),
    $31129e6bc8797155$var$load("dWZbK"),
    $31129e6bc8797155$var$load("iqKwT"),
    $31129e6bc8797155$var$load("kULV9"),
    $31129e6bc8797155$var$load("jEmf3"),
    $31129e6bc8797155$var$load("kUbUu"),
    $31129e6bc8797155$var$load("2PePB"),
    $31129e6bc8797155$var$load("lnKog"),
    $31129e6bc8797155$var$load("9ftJe"),
    $31129e6bc8797155$var$load("euYY7"),
    $31129e6bc8797155$var$load("kC80R"),
    $31129e6bc8797155$var$load("7EorR"),
    $31129e6bc8797155$var$load("aFNXd")
]).then(()=>parcelRequire('cgoGN'));

});

parcelRegister("hIaUw", function(module, exports) {
const $5ff3d548ffdc5eda$export$1ef77878e4e0b972 = (routeName)=>{
    if (routeName?.includes('PAGE')) return 'page';
    if (routeName?.includes('BLOG')) return 'blogpost';
    if (routeName?.includes('SPACE')) return 'space';
    return 'page';
};
module.exports["getContentType"] = $5ff3d548ffdc5eda$export$1ef77878e4e0b972;

});

parcelRegister("8a9Dm", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");

const $2cc1b73219e08564$export$fb2283f4a44fb53 = (app)=>{
    if (!app?.id) return;
    const [, id] = app.id.split('/');
    return id;
};
const $2cc1b73219e08564$export$b17b21a48c0a3273 = (module)=>{
    if (!module.id) return;
    const parts = module.id.split('/');
    return parts[parts.length - 1];
};
const $2cc1b73219e08564$var$isMigratedFromConnect = (app)=>{
    if (!app.properties) return false;
    const props = app.properties;
    return props.migratedFromConnect === true || props.migratedFromConnect === 'true';
};
const $2cc1b73219e08564$export$9eb690901638fb96 = (app)=>{
    if ($2cc1b73219e08564$var$isMigratedFromConnect(app) && app.migrationKey && (0, $9wGTI.fg)('confluence-fe-migrated-custom-content-display-fix')) return `ac:${app.migrationKey}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
    return `forge:${$2cc1b73219e08564$export$fb2283f4a44fb53(app)}:${app.environmentId}:${$2cc1b73219e08564$export$b17b21a48c0a3273(app)}`;
};
module.exports["getAppId"] = $2cc1b73219e08564$export$fb2283f4a44fb53;
module.exports["getModuleKey"] = $2cc1b73219e08564$export$b17b21a48c0a3273;
module.exports["getCustomContentType"] = $2cc1b73219e08564$export$9eb690901638fb96;

});

parcelRegister("dizL5", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $55b20ed34f146485$export$350b371bfb7f5e95 = (loadingComponent)=>(0, $jmjWc.LoadableAfterPaint)({
        __loadable_id__: "UJdch",
        name: "lazyForgeUIExtensionsWithLoader",
        loader: async ()=>(await (parcelRequire("kxN5Y"))).ForgeUIExtensionsWrapper,
        loading: loadingComponent
    });
const $55b20ed34f146485$export$4cbc6d03d50a8849 = $55b20ed34f146485$export$350b371bfb7f5e95(undefined);
module.exports["lazyForgeUIExtensionsWithLoader"] = $55b20ed34f146485$export$350b371bfb7f5e95;
module.exports["LazyForgeUIExtensions"] = $55b20ed34f146485$export$4cbc6d03d50a8849;

});

parcelRegister("kxN5Y", function(module, exports) {

let $ef4cf9036132d263$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ef4cf9036132d263$var$load("2PePB"),
    $ef4cf9036132d263$var$load("lnKog")
]).then(()=>parcelRequire('2mcHd'));

});

parcelRegister("6UqI3", function(module, exports) {
const $a3c7cd489159fe33$export$28eddf802cd184f7 = (spaceKey)=>{
    return spaceKey?.[0] === '~' ? 'personal' : 'global';
};
module.exports["getSpaceType"] = $a3c7cd489159fe33$export$28eddf802cd184f7;

});

parcelRegister("c54hr", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $367766f6f044c46b$var$initialState = {
    isMenuOpen: false,
    isCloseMenuDisabled: false
};
const $367766f6f044c46b$var$actions = {
    setIsMenuOpen: (isMenuOpen)=>({ setState: setState })=>{
            setState({
                isMenuOpen: isMenuOpen
            });
        },
    setIsCloseMenuDisabled: (isCloseMenuDisabled)=>({ setState: setState })=>{
            setState({
                isCloseMenuDisabled: isCloseMenuDisabled
            });
        }
};
const $367766f6f044c46b$var$Store = (0, $1P1Tu.createStore)({
    initialState: $367766f6f044c46b$var$initialState,
    actions: $367766f6f044c46b$var$actions,
    name: 'more-actions-menu-store'
});
const $367766f6f044c46b$export$14d00db016c2b3ef = (0, $9zUhf.createStateHook)($367766f6f044c46b$var$Store);
const $367766f6f044c46b$export$1f1f8c486fa8a1cb = (0, $9zUhf.createActionsHook)($367766f6f044c46b$var$Store);
module.exports["useMoreActionsMenuState"] = $367766f6f044c46b$export$14d00db016c2b3ef;
module.exports["useMoreActionsMenuActions"] = $367766f6f044c46b$export$1f1f8c486fa8a1cb;

});

parcelRegister("9fBoq", function(module, exports) {
parcelRequire("1c598");
var $1Aku8 = parcelRequire("1Aku8");

const $6ca0453d93f30f16$var$capitalize = (str)=>{
    if (!str || !str.length) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
const $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e = (extension, overriddenTitle)=>{
    const title = overriddenTitle || extension.properties.title;
    const { environmentType: environmentType, environmentKey: environmentKey } = extension;
    if (environmentType === (0, $1Aku8.ProductEnvironment).PRODUCTION) return title;
    if (environmentType === (0, $1Aku8.ProductEnvironment).DEVELOPMENT && environmentKey !== 'default') return `${title} - ${environmentKey} (Dev)`;
    return `${title} (${$6ca0453d93f30f16$var$capitalize(environmentType)})`;
};
module.exports["extensionTitle"] = $6ca0453d93f30f16$export$9dd0cb91ff7c8b7e;

});

parcelRegister("1c598", function(module, exports) {
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);
parcelRequire("i3Ypo");
var $2JC3k = parcelRequire("2JC3k");
var $1Aku8 = parcelRequire("1Aku8");
var $9dbGT = parcelRequire("9dbGT");

parcelRequire("jUCNB");
var $gUjm2 = parcelRequire("gUjm2");
var $kg3OT = parcelRequire("kg3OT");
var $fsQJy = parcelRequire("fsQJy");


});

parcelRegister("i3Ypo", function(module, exports) {
$parcel$export(module.exports, "MarkupRecursiveList", () => (parcelRequire("9dbGT")).MarkupRecursiveList);
$parcel$export(module.exports, "MarkupList", () => (parcelRequire("9dbGT")).MarkupList);
$parcel$export(module.exports, "ProductEnvironment", () => (parcelRequire("1Aku8")).ProductEnvironment);
$parcel$export(module.exports, "ForgeCDNEnvironment", () => (parcelRequire("1Aku8")).ForgeCDNEnvironment);
$parcel$export(module.exports, "ConfluenceExtension", () => (parcelRequire("2JC3k")).ConfluenceExtension);
$parcel$export(module.exports, "ExtensionEnvironment", () => (parcelRequire("2JC3k")).ExtensionEnvironment);
$parcel$export(module.exports, "JiraExtension", () => (parcelRequire("2JC3k")).JiraExtension);

var $9dbGT = parcelRequire("9dbGT");


var $1Aku8 = parcelRequire("1Aku8");


var $6sM2K = parcelRequire("6sM2K");


var $2JC3k = parcelRequire("2JC3k");


});

parcelRegister("9dbGT", function(module, exports) {
const $1ec3e8240f57817b$export$3b98ab6402702476 = [
    'Em',
    'Link',
    'Strike',
    'String',
    'Strong',
    'User'
];
const $1ec3e8240f57817b$export$3ee8c58bb87b9685 = [
    ...$1ec3e8240f57817b$export$3b98ab6402702476,
    'Badge',
    'Code',
    'DateLozenge',
    'StatusLozenge',
    'Tag',
    'UserGroup'
];
module.exports["MarkupRecursiveList"] = $1ec3e8240f57817b$export$3b98ab6402702476;
module.exports["MarkupList"] = $1ec3e8240f57817b$export$3ee8c58bb87b9685;

});

parcelRegister("1Aku8", function(module, exports) {
var $d128cc36ec70c56c$export$2688cec3c24cb60b = /*#__PURE__*/ function(ProductEnvironment) {
    ProductEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ProductEnvironment["STAGING"] = "STAGING";
    ProductEnvironment["PRODUCTION"] = "PRODUCTION";
    return ProductEnvironment;
}({});
var $d128cc36ec70c56c$export$beaef1891b3e7ca3 = /*#__PURE__*/ function(ForgeCDNEnvironment) {
    ForgeCDNEnvironment["DEVELOPMENT"] = "dev";
    ForgeCDNEnvironment["STAGING"] = "stg";
    ForgeCDNEnvironment["PRODUCTION"] = "prod";
    return ForgeCDNEnvironment;
}({});
module.exports["ProductEnvironment"] = $d128cc36ec70c56c$export$2688cec3c24cb60b;
module.exports["ForgeCDNEnvironment"] = $d128cc36ec70c56c$export$beaef1891b3e7ca3;

});

parcelRegister("6sM2K", function(module, exports) {
const $0e3337cb4407ef3b$export$21b318cfdd670495 = (error)=>({
        type: 'render',
        aux: {
            type: 'View',
            children: [
                {
                    type: 'ErrorPanel',
                    props: {
                        error: error
                    },
                    children: []
                }
            ]
        },
        state: {}
    });

});

parcelRegister("2JC3k", function(module, exports) {
var $d977f97374f9d2c9$export$6e95f5308d9156f9 = /*#__PURE__*/ function(ExtensionEnvironment) {
    ExtensionEnvironment["DEVELOPMENT"] = "DEVELOPMENT";
    ExtensionEnvironment["STAGING"] = "STAGING";
    ExtensionEnvironment["PRODUCTION"] = "PRODUCTION";
    return ExtensionEnvironment;
}({});
const $d977f97374f9d2c9$export$9a2372818e2520c6 = {
    BYLINE: 'confluence:contentBylineItem',
    CONTEXT_MENU: 'confluence:contextMenu',
    CONTENT_ACTION: 'confluence:contentAction',
    GLOBAL_PAGE: 'confluence:globalPage',
    GLOBAL_SETTINGS: 'confluence:globalSettings',
    HOMEPAGE_FEED: 'confluence:homepageFeed',
    SPACE_PAGE: 'confluence:spacePage',
    SPACE_SETTINGS: 'confluence:spaceSettings',
    CUSTOM_CONTENT: 'confluence:customContent',
    MACRO: 'xen:macro',
    TEST_MODULE: 'test:module'
};
const $d977f97374f9d2c9$export$f06ffa3aa6bfec95 = {
    BACKLOG_ACTION: 'jira:backlogAction',
    BOARD_ACTION: 'jira:boardAction',
    PERSONAL_SETTINGS_PAGE: 'jira:personalSettingsPage',
    ISSUE_PANEL: 'jira:issuePanel',
    ISSUE_ACTION: 'jira:issueAction',
    ISSUE_GLANCE: 'jira:issueGlance',
    ISSUE_CONTEXT: 'jira:issueContext',
    ISSUE_ACTIVITY: 'jira:issueActivity',
    UI_MODIFICATIONS: 'jira:uiModifications',
    CUSTOM_FIELD: 'jira:customField',
    CUSTOM_FIELD_TYPE: 'jira:customFieldType',
    ADMIN_PAGE: 'jira:adminPage',
    GLOBAL_PAGE: 'jira:globalPage',
    PROJECT_PAGE: 'jira:projectPage',
    PROJECT_SETTINGS_PAGE: 'jira:projectSettingsPage',
    DASHBOARD_BACKGROUND_SCRIPT: 'jira:dashboardBackgroundScript',
    ISSUE_VIEW_BACKGROUND_SCRIPT: 'jira:issueViewBackgroundScript',
    DASHBOARD_GADGET: 'jira:dashboardGadget',
    WORKFLOW_VALIDATOR: 'jira:workflowValidator',
    WORKFLOW_CONDITION: 'jira:workflowCondition',
    WORKFLOW_POST_FUNCTION: 'jira:workflowPostFunction',
    SERVICE_DESK_QUEUE_PAGE: 'jiraServiceManagement:queuePage',
    SERVICE_DESK_ORGANIZATION_PANEL: 'jiraServiceManagement:organizationPanel'
};
module.exports["ExtensionEnvironment"] = $d977f97374f9d2c9$export$6e95f5308d9156f9;
module.exports["ConfluenceExtension"] = $d977f97374f9d2c9$export$9a2372818e2520c6;
module.exports["JiraExtension"] = $d977f97374f9d2c9$export$f06ffa3aa6bfec95;

});

parcelRegister("jUCNB", function(module, exports) {

var $fsQJy = parcelRequire("fsQJy");


var $kg3OT = parcelRequire("kg3OT");


var $gUjm2 = parcelRequire("gUjm2");


});

parcelRegister("fsQJy", function(module, exports) {
// DELETE FILE http://go/j/FUI-1091
const $8d78496ee677e86d$export$7e816460364ed464 = (effect)=>{
    return effect.type === 'initialize';
};
const $8d78496ee677e86d$export$eb5bd7f371e458af = (effect)=>{
    return effect.type === 'action';
};
const $8d78496ee677e86d$export$f632ad3064955f31 = (effect)=>{
    return effect.type === 'event';
};
const $8d78496ee677e86d$export$dfeb34e64fee2572 = (effect)=>{
    return effect.type === 'render';
};
function $8d78496ee677e86d$export$20b9f6acb0888554(effect) {
    return $8d78496ee677e86d$export$7e816460364ed464(effect) || $8d78496ee677e86d$export$eb5bd7f371e458af(effect) || $8d78496ee677e86d$export$f632ad3064955f31(effect);
}

});

parcelRegister("kg3OT", function(module, exports) {
const $bc3454970f51a505$export$709a27a9f80556b8 = (effect)=>{
    return effect.type === 'event';
};
const $bc3454970f51a505$export$65d7078e01574f24 = (effect)=>{
    return effect.type === 'action';
};
const $bc3454970f51a505$export$8089f608f1d0c22d = (effect)=>{
    return effect.type === 'render';
};
const $bc3454970f51a505$export$84909efba3133df = (effect)=>{
    return effect.type === 'result';
};
function $bc3454970f51a505$export$caa8cab0db5b0a61(effect) {
    return $bc3454970f51a505$export$65d7078e01574f24(effect) || $bc3454970f51a505$export$709a27a9f80556b8(effect) || $bc3454970f51a505$export$8089f608f1d0c22d(effect);
}

});

parcelRegister("gUjm2", function(module, exports) {
// From forge.ts
const $ce9f8921033c0d6d$export$3ab8eca5875a9c7e = (auxNode)=>{
    return auxNode !== null && typeof auxNode !== 'boolean' && auxNode !== undefined;
};
var $ce9f8921033c0d6d$export$c8914e6b1e019577 = /*#__PURE__*/ function(EcosystemLicenseMode) {
    EcosystemLicenseMode["USER_ACCESS"] = "USER_ACCESS";
    return EcosystemLicenseMode;
}({});
const $ce9f8921033c0d6d$export$a3b8d8814f1b9262 = (context)=>context.type === 'jira';
const $ce9f8921033c0d6d$export$d8e8de7bd6b731b7 = (extensionContext)=>extensionContext.type === 'issuePanel';
const $ce9f8921033c0d6d$export$1404d10ac8f82a03 = (extensionContext)=>extensionContext.type === 'contextConfig';
const $ce9f8921033c0d6d$export$9e5e0ca9e718a261 = (extensionContext)=>extensionContext.type === 'customField' || extensionContext.type === 'customFieldType';
const $ce9f8921033c0d6d$export$2f4ddb77a2467d4a = (extensionContext)=>extensionContext.type === 'contextMenu';
const $ce9f8921033c0d6d$export$dfe2b8f5623b1a39 = (extensionContext)=>extensionContext.type === 'contentAction';
const $ce9f8921033c0d6d$export$aee7a41cc3ed0e4 = (extensionContext)=>extensionContext.type === 'dashboardGadget';
var $ce9f8921033c0d6d$export$24835b97bd9481e3 = /*#__PURE__*/ function(CompassContextTypes) {
    CompassContextTypes["AdminPage"] = "compass:adminPage";
    CompassContextTypes["ComponentPage"] = "compass:componentPage";
    CompassContextTypes["TeamPage"] = "compass:teamPage";
    CompassContextTypes["ComponentImporter"] = "compass:componentImporter";
    return CompassContextTypes;
}({});
var $ce9f8921033c0d6d$export$1718b7e1799fa866 = /*#__PURE__*/ function(RenderingLocations) {
    RenderingLocations["AppConfigurationPage"] = "appConfigurationPage";
    RenderingLocations["OnboardingFlow"] = "onboardingFlow";
    return RenderingLocations;
}({});

});

parcelRegister("9MrOn", function(module, exports) {
/* ContentToolsButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $4xcIM = parcelRequire("4xcIM");


var $cgtv4 = parcelRequire("cgtv4");

var $8C5kA = parcelRequire("8C5kA");


var $9VJDA = parcelRequire("9VJDA");


var $1qfLF = parcelRequire("1qfLF");


var $52EPl = parcelRequire("52EPl");

const $43c0d8bb08806c39$var$NOOP = ()=>{};
const $43c0d8bb08806c39$var$i18n = (0, $cgtv4.defineMessages)({
    triggerLabel: {
        id: "content-tools.more.icon.label",
        defaultMessage: "More actions"
    }
});
const $43c0d8bb08806c39$var$dropdownMenuCollaboratorStyle = null;
const $43c0d8bb08806c39$var$dropdownMenuNonCollaboratorStyle = null;
const $43c0d8bb08806c39$var$ContentToolsButtonComponent = ({ isDisabled: isDisabled, isOpen: isOpen = false, onOpenChange: onOpenChange = $43c0d8bb08806c39$var$NOOP, onPositioned: onPositioned = $43c0d8bb08806c39$var$NOOP, children: children, isExternalCollaborator: isExternalCollaborator = false })=>{
    'use no memo';
    const intl = (0, $8C5kA.default)();
    const [drodownMenuMaxHeight, setDropdownMenuMaxHeight] = (0, $42omo.useState)('auto');
    const dropdownMenuContainerRef = (0, $42omo.useRef)(null);
    const handleOnOpenChange = (obj)=>{
        onOpenChange(obj);
        if (obj.isOpen) {
            const distanceFromTop = dropdownMenuContainerRef.current?.getBoundingClientRect().bottom ?? 0;
            const availableHeight = window.innerHeight - distanceFromTop - 16;
            setDropdownMenuMaxHeight(`${availableHeight}px`);
        }
    };
    return /*#__PURE__*/ $42omo.createElement("div", {
        "data-id": "content-tools-dropdown-menu-container",
        "data-test-id": "content-tools-dropdown-menu-container",
        "data-testid": "content-tools-dropdown-menu-container",
        ref: dropdownMenuContainerRef,
        className: (0, $gMc0m.default)([
            "_18u019bv _1ul91tcg",
            isExternalCollaborator && "_18u0idpf _1ul91tcg"
        ])
    }, /*#__PURE__*/ $42omo.createElement((0, $52EPl.default), {
        testId: "content-tools-dropdown-menu",
        appearance: "tall",
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ $42omo.createElement((0, $1qfLF.default), {
                ...props,
                "data-id": "page-more-action-button",
                "data-test-id": "page-more-action-button",
                id: "tools-menu-trigger",
                label: intl.formatMessage($43c0d8bb08806c39$var$i18n.triggerLabel),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
                ref: triggerRef,
                appearance: "subtle",
                isDisabled: isDisabled
            }),
        placement: "bottom-end",
        isOpen: isOpen,
        onOpenChange: handleOnOpenChange,
        shouldFlip: false,
        onPositioned: onPositioned,
        shouldRenderToParent: true
    }, /*#__PURE__*/ $42omo.createElement("div", {
        style: {
            maxHeight: drodownMenuMaxHeight
        }
    }, children || null)));
};
$43c0d8bb08806c39$var$ContentToolsButtonComponent.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isExternalCollaborator: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
    onPositioned: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func
};
const $43c0d8bb08806c39$export$f221d384e5b0f4c3 = /*#__PURE__*/ (0, $42omo.memo)($43c0d8bb08806c39$var$ContentToolsButtonComponent);
module.exports["ContentToolsButton"] = $43c0d8bb08806c39$export$f221d384e5b0f4c3;

});


//# sourceMappingURL=ForgeContentTools.060a677f.js.map
